import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../actions/api"; // Your Axios instance
import { showLoader, hideLoader } from "./loaderSlice";
import { showSnackBar } from "./snackSlice";

// GET all discounts
export const getDiscounts = createAsyncThunk(
  "discount/getDiscounts",
  async (_, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).get("/getall/clinic/billings");
      if (res.status === 200) {
        thunkAPI.dispatch(hideLoader());
        return res.data.data;
      }
      thunkAPI.dispatch(hideLoader());
      return [];
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(showSnackBar({ message: "Failed to fetch discounts", type: "error" }));
      return thunkAPI.rejectWithValue(err.response?.data || err.message);
    }
  }
);

// POST create discount
export const createDiscount = createAsyncThunk(
  "discount/createDiscount",
  async (formData, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).post("/create/clinic/billing", formData);
      if (res.status === 200 || res.status === 201) {
        thunkAPI.dispatch(hideLoader());
        thunkAPI.dispatch(showSnackBar({ message: "Discount created successfully!", type: "success" }));
        return res.data.data;
      }
      thunkAPI.dispatch(hideLoader());
      return thunkAPI.rejectWithValue("Failed to create discount");
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(showSnackBar({ message: "Failed to create discount", type: "error" }));
      return thunkAPI.rejectWithValue(err.response?.data || err.message);
    }
  }
);

// PUT update discount
export const updateDiscount = createAsyncThunk(
  "discount/updateDiscount",
  async ({ id, ...formData }, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).put(`/update/clinic/billing/${id}`, formData);
      if (res.status === 200) {
        thunkAPI.dispatch(hideLoader());
        thunkAPI.dispatch(showSnackBar({ message: "Discount updated successfully!", type: "success" }));
        return res.data.data;
      }
      thunkAPI.dispatch(hideLoader());
      return thunkAPI.rejectWithValue("Failed to update discount");
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(showSnackBar({ message: "Failed to update discount", type: "error" }));
      return thunkAPI.rejectWithValue(err.response?.data || err.message);
    }
  }
);

// DELETE discount
export const deleteDiscount = createAsyncThunk(
  "discount/deleteDiscount",
  async (id, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).delete(`/delete/clinic/billing/${id}`);
      if (res.status === 200) {
        thunkAPI.dispatch(hideLoader());
        thunkAPI.dispatch(showSnackBar({ message: "Discount deleted successfully!", type: "success" }));
        return id;
      }
      thunkAPI.dispatch(hideLoader());
      return thunkAPI.rejectWithValue("Failed to delete discount");
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(showSnackBar({ message: "Failed to delete discount", type: "error" }));
      return thunkAPI.rejectWithValue(err.response?.data || err.message);
    }
  }
);

const initialState = {
  discounts: [],
  loading: false,
  error: null,
};

const discountSlice = createSlice({
  name: "discount",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getDiscounts.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getDiscounts.fulfilled, (state, action) => {
        state.loading = false;
        state.discounts = Array.isArray(action.payload) ? action.payload : [action.payload];
      })
      .addCase(getDiscounts.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(createDiscount.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createDiscount.fulfilled, (state, action) => {
        state.loading = false;
        state.discounts.push(action.payload);
      })
      .addCase(createDiscount.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(updateDiscount.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateDiscount.fulfilled, (state, action) => {
        state.loading = false;
        const index = state.discounts.findIndex(d => d.billId === action.payload.billId);
        if (index !== -1) {
          state.discounts[index] = action.payload;
        }
      })
      .addCase(updateDiscount.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(deleteDiscount.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteDiscount.fulfilled, (state, action) => {
        state.loading = false;
        state.discounts = state.discounts.filter(d => d.billId !== action.payload);
      })
      .addCase(deleteDiscount.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default discountSlice.reducer;

// // Export actions
// export const { getDiscounts, createDiscount, updateDiscount, deleteDiscount } = discountSlice.actions;